import { isJourneyId, resolveJourneyId } from '@glomopay/analytics';

export const journeyId = resolveJourneyId(window.location.search);

export const isJourneyEntry = !isJourneyId(new URLSearchParams(window.location.search).get('journeyId')) && window.top === window.self;
